import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { isEmpty } from 'lodash';
import { HisUiService } from '../../core/service/base/his-ui.service';
import { HisArrayUtils } from '../../core/utils';
import { HisOperatorTrigger } from '../model/his-operator-trigger';
import { HisOption } from '../model/his-option';
import { HisSearchConfiguration } from '../model/his-search-configuration';
import { HisSearchCriteriagroup } from '../model/his-search-criteriagroup';
import { HisSelectComparatorType } from '../model/his-select-comparator-type';
import { HisSelectOperatorType } from '../model/his-select-operator-type';
import { HisWidgetBase } from '../model/his-widget-base';
import { HisWidgetBaseSelect } from '../model/his-widget-base-select';
import { HisWidgetGroup } from '../model/his-widget-group';
import { HisOptionWidget } from '../model/his-widget-option';
import { HisSelectWidget } from '../model/his-widget-select';
import { OptionByIdRequest } from '../model/options/option-by-id-request';
import { SelectedOptions } from '../model/options/selected-options';
import { HisSearchCriteria, HisSearchGroup } from '../model/search/his-search';
import { HisSearchConstants } from '../model/search/his-search-constants';
import { HisSearchParserHelper } from '../model/search/his-search-parser-helper';
import { HisSearchService } from '../service/his-search.service';
import { HisWidgetService } from '../service/his-widget.service';
import { GenericSearchUtil } from '../utils/generic-search-util';
import { HisQueryParamUtils } from '../utils/his-query-param-utils';
import { HisWidgetUtils } from '../utils/his-widget-utils';
export class HisSearchFormData {

    private widgetsToDisplayFromSearchSet: HisWidgetBase<any>[] = [];

    searchConfiguration: HisSearchConfiguration;

    // widgets structured by widgetGroups (each group represents a fieldset)
    widgetGroups: HisWidgetGroup[];

    form: UntypedFormGroup;


    constructor(
        protected widgetService: HisWidgetService,
        protected searchService: HisSearchService,
        protected uiService: HisUiService
    ) { }

    getSearchConfiguration(): HisSearchConfiguration {
        return this.searchConfiguration;
    }

    copyWidgetsFromGroupAndCreateCriteriaGroup( searchGroup: HisSearchGroup, doLoadLazyWidgets: boolean = true ) {
        for ( let searchCriteriaGroup of searchGroup.criteriaGroups ) {
            console.log( 'CriteriaGroup #searchCriteriaGroup', searchCriteriaGroup );
            let originalWidgetGroup = HisWidgetUtils.getWidgetGroupWithLabel( searchGroup.groupLabel, this.widgetGroups );
            console.log( 'CriteriaGroup #originalWidgetGroup', originalWidgetGroup );
            if ( !originalWidgetGroup ) {
                // FEHLER
                continue;
            }

            let combineCriteriaGroupsByOr = searchGroup.criteriaGroupAnd ? false : true;
            originalWidgetGroup.combineCriteriaGroupsByOr = combineCriteriaGroupsByOr;

            let groupIndex = String( searchGroup.criteriaGroups.indexOf( searchCriteriaGroup ) );
            let newSearchCriteriaGroup = new HisSearchCriteriagroup();
            newSearchCriteriaGroup.notInCriteriaGroup = searchCriteriaGroup.excluding ? true : false;

            for ( let originalWidget of originalWidgetGroup.widgets ) {
                console.log(
                    'his-search-form.component#copyWidgetsFromGroupAndCreateCriteriaGroup() #originalWidget', originalWidget );
                // nicht verwirren lassen: in der URL werden keine Klammern verwendet, also auch nicht in den params
                // Es ist die erste kriteriengruppe, deshalb [0]

                let newId = originalWidgetGroup.label + '[' + groupIndex + ']' + originalWidget.id;
                // console.log('his-search-form.component#restoreCriteriaGroupWidgetsForSearchConstraints()', '#newId' , newId);
                let copyOfWidget = this.copyWidget( originalWidget, newId );
                console.log(
                    'his-search-form.component#copyWidgetsFromGroupAndCreateCriteriaGroup() #copyOfWidget',
                    copyOfWidget );
                let criterion = HisSearchParserHelper.getCriterionWithPath( originalWidget.id, searchCriteriaGroup.criteria );
                console.log( 'CriteriaGroup #searchCriteriaGroup', criterion );
                let criteriaGroupWidget = this.createCriteriaGroupWidgetsAndUpdateControl( criterion, copyOfWidget, doLoadLazyWidgets );
                newSearchCriteriaGroup.widgets.push( criteriaGroupWidget );
            }

            console.log(
                'his-search-form.component#copyWidgetsFromGroupAndCreateCriteriaGroup() #newSearchCriteriaGroup',
                newSearchCriteriaGroup );

            originalWidgetGroup.updateCriteriaGroups( group => [...group, newSearchCriteriaGroup] );
        }
    }

    private copyWidget( original: HisWidgetBase<any>, newId: string ): HisWidgetBase<any> {
        let copy = this.widgetService.copyWidget( original, newId );
        copy.value = null;
        copy.originalValue = null;
        if ( copy instanceof HisWidgetBaseSelect ) {
            copy.not = false;
            copy.originalNot = false;
        }
        return copy;
    }

    createCriteriaGroupWidgetsAndUpdateControl(
        criterion: HisSearchCriteria,
        copyOfWidget: HisWidgetBase<any>,
        doLoadLazyWidgets: boolean = true ): HisWidgetBase<any> {
        if ( !criterion || !criterion.value ) {
            // Wenn es für ein Widget keine Kriterien gibt, dann die Kopie ohne aktualisierte Werte hinzufügen
            this.addOrUpdateControl( copyOfWidget, undefined );
            return copyOfWidget;
        }

        // Wenn es ein Criterion gibt
        if ( copyOfWidget instanceof HisWidgetBaseSelect ) {
            this.triggerOperator( criterion.not, copyOfWidget as HisWidgetBaseSelect<any> );
            let widgetSelectCopy = this.copyWidgetBaseSelectAndAddToFormControl( copyOfWidget, criterion, doLoadLazyWidgets );
            // this.addOrUpdateControl wird in copyWidgetBaseSelectAndAddToFormControl gemacht
            console.log( 'createCriteriaGroupWidgetsAndUpdateControl #widgetSelectCopy', widgetSelectCopy );
            return widgetSelectCopy;

        } else if ( copyOfWidget instanceof HisOptionWidget ) {
            if ( criterion.value ) {
                // console.log('his-search-form.component#setWidgetGroups() #checkbox value', loadedCriterion.value);
                // console.log('his-search-form.component#setWidgetGroups() #copyOfWidget', copyOfWidget);
                copyOfWidget.option = criterion.value;
                let trueValue: any = true;
                copyOfWidget.value = trueValue;
                copyOfWidget.originalValue = trueValue;

                this.addOrUpdateControl( copyOfWidget, trueValue );
                return copyOfWidget;
            }
            return undefined;
        } else {
            // Eingabefeld aktualisieren, value: string
            if ( copyOfWidget.id !== criterion.value ) {
                // console.log('his-search-form.component#setWidgetGroups() #input, date', criterion.value);
                // console.log('his-search-form.component#setWidgetGroups() #copyOfWidget', copyOfWidget);
                copyOfWidget.value = criterion.value;
                copyOfWidget.originalValue = criterion.value;

                this.addOrUpdateControl( copyOfWidget, criterion.value );
                return copyOfWidget;
            }
            return undefined;
        }
    }

    addOrUpdateControl( widget: HisWidgetBase<any>, value: any ) {
        let hasKey = Object.keys( this.form.controls ).includes( widget.id );
        if ( hasKey ) {
            this.form.removeControl( widget.id );
            this.form.addControl( widget.id, new UntypedFormControl( value ) );
        } else {
            this.form.addControl( widget.id, new UntypedFormControl( value ) );
        }
    }

    triggerOperator(
        not: boolean,
        widgetToSet: HisWidgetBaseSelect<any> ) {

        if ( widgetToSet === null ) {
            console.warn( 'HisSearchSaveParams loadedtWidget.value === null' );
            return;
        }

        console.log( 'his-search-save-params triggerOperator loadedtWidget.not', not );
        console.log( 'his-search-save-params triggerOperator widget.id', widgetToSet.id );

        let operatorType: HisSelectOperatorType;

        const parseResult = this.applyOperator( widgetToSet.value );
        if ( parseResult ) {
            operatorType = parseResult.flag === false
                ? HisSelectOperatorType.UNEQUAL  
                : HisSelectOperatorType.EQUAL;    

            widgetToSet.value = parseResult.value;
        } else {
            operatorType = not
                ? HisSelectOperatorType.UNEQUAL
                : HisSelectOperatorType.EQUAL;
        }

        const operatorTrigger = new HisOperatorTrigger( operatorType, widgetToSet );
        this.searchService.setOperator( operatorTrigger );
    }

    applyOperator( op: any ) {
        if ( typeof op !== 'string' ) {
            return null;
        }

        const [operator, number] = op.split( '|' );

        if ( !operator || !number ) {
            return null;
        }

        const isValidOperator = operator === HisSelectComparatorType.NE || operator === HisSelectComparatorType.EQ;

        if ( !isValidOperator ) {
            // Unknown operator → values remain undefined
            return {
                flag: undefined,
                value: undefined
            };
        }

        return {
            flag: operator === HisSelectComparatorType.EQ,
            value: number
        };
    }

    copyWidgetBaseSelectAndAddToFormControl(
        copyOfWidget: HisWidgetBaseSelect<any>,
        criterion: HisSearchCriteria,
        doLoadLazyWidgets: boolean = true ): HisWidgetBaseSelect<any> {
        console.log( 'convertStringToValueType(): #copyOfWidget', copyOfWidget );

        if ( criterion && criterion.value === 'ISNULL' ) {
            console.log( 'copyWidgetBaseSelectAndAddToFormControl(): #criterion', criterion );
            console.log( 'copyWidgetBaseSelectAndAddToFormControl(): #copyOfWidget', copyOfWidget );
            const nullValueOption = this.uiService.translate( 'genericSearch.nullValueMenuEntry' );
            let newOption = new HisOption();
            newOption.id = criterion.field;
            newOption.label = nullValueOption;

            if ( copyOfWidget.kind === 'dropdown' ) {
                copyOfWidget.value = newOption;
                copyOfWidget.originalValue = newOption;
                copyOfWidget.not = criterion.not;
                copyOfWidget.originalNot = criterion.not;
                this.addOrUpdateControl( copyOfWidget, 'ISNULL' );
            }
            if ( copyOfWidget.kind === 'multi-dropdown' ) {
                copyOfWidget.value.push( newOption );
                copyOfWidget.originalValue.push( newOption );
                copyOfWidget.not = criterion.not;
                copyOfWidget.originalNot = criterion.not;
                this.addOrUpdateControl( copyOfWidget, 'ISNULL' );
            }
            return copyOfWidget;
        }

        console.log( 'his-search-form.component#copyWidgetBaseSelectAndAddToFormControl() #criterion', criterion );
        let isLidSearch = GenericSearchUtil.isLidPath( copyOfWidget.id );

        //if doLoadLAzyWidgets && isLazywidget: skip getWidgetValues
        const isLazySelectWidget: boolean = copyOfWidget instanceof HisSelectWidget && GenericSearchUtil.isLazySelectFrom( copyOfWidget.optionsKey, copyOfWidget.showDropdownIcon );
        if ( doLoadLazyWidgets || !isLazySelectWidget ) {
            copyOfWidget.getWidgetValues( criterion.value, isLidSearch ).subscribe( option => {
                if ( option && !HisArrayUtils.isEmptyArray( option ) ) {
                    console.log( 'his-search-form.component#copyWidgetBaseSelectAndAddToFormControl() #option', option );

                    copyOfWidget.value = option;
                    copyOfWidget.originalValue = Array.isArray( option ) ? [...option] : option;

                    copyOfWidget.not = criterion.not;
                    copyOfWidget.originalNot = criterion.not;

                    this.addOrUpdateControl( copyOfWidget, option );

                }
            } );
        }

        return copyOfWidget;
    }

    doPresetInputFields( presets: any ) {
        if ( !presets || isEmpty( presets ) || !this.widgetGroups ) {
            return;
        }
        const widgetPresets = this.convertToWidgetFormat( presets );

        for ( let widgetGroup of this.widgetGroups ) {
            widgetGroup.presetInputFields( widgetPresets );
        }

        //handle lazy widgets in a combined rest call
        this.presetLazyInputFields( widgetPresets );
    }

    /**
     * converts the given input of presets to the format used to init the widgets
     * @param presets may be either format of as specified by i.e. HisSearchSelectPopupComponentBase#presetInputFields or widget definition as returned by {@link buildWidgetDefinitions}
     * @returns
     */
    private convertToWidgetFormat( presets: any ): any {
        interface CriteriaValuePair {
            criteria: string;
            value: string;
            fromCriteriaGroup: boolean;
        }

        const allWidgets = this.widgetGroups.flatMap( group => group.widgets );
        const groupMap = new Map<string, CriteriaValuePair[]>();

        function getGroup( group: string ) {
            if ( !groupMap.has( group ) ) {
                groupMap.set( group, [] );
            }
            return groupMap.get( group );
        }

        function isWidgetReference( idOrPresetKey: string ) {
            return idOrPresetKey.startsWith( HisSearchConstants.GROUPS ) && idOrPresetKey.endsWith( HisSearchConstants.FIELD );
        }

        function getMatchingWidget( idOrPresetKey: string ) {
            if ( isWidgetReference( idOrPresetKey ) ) {
                const criteria = presets[idOrPresetKey];
                return allWidgets.find( widget => widget.id === criteria );
            }
            return allWidgets.find( widget => widget.id === idOrPresetKey );
        }

        function isCriteriaGroupPreset( widget: any, presetKey: string ): boolean {
            const path = widget.id;
            const pathOfWidget = presets[presetKey];

            if ( path !== pathOfWidget ) {
                return false;
            }

            return presetKey.includes( HisSearchConstants.CRITERIA_GROUPS );
        }

        function getCriteriaAndValue( idOrPresetKey: string, fromCriteriaGroup: boolean ): CriteriaValuePair {
            if ( isWidgetReference( idOrPresetKey ) ) {
                const criteria = presets[idOrPresetKey];
                const value = presets[idOrPresetKey.replace( HisSearchConstants.FIELD, HisSearchConstants.VALUE )];

                return { criteria, value, fromCriteriaGroup };
            }

            return { criteria: idOrPresetKey, value: presets[idOrPresetKey], fromCriteriaGroup };
        }

        const presetKeys = Object.keys( presets );
        for ( let presetKey of presetKeys ) {
            const widget = getMatchingWidget( presetKey );
            if ( !widget ) {
                continue;
            }

            const isGroup = isCriteriaGroupPreset( widget, presetKey );
            const group = getGroup( widget.group );
            group.push( getCriteriaAndValue( presetKey, isGroup ) );
        }

        const groupKeys = Array.from( groupMap.keys() );

        return this.buildWidgetDefinitions( groupKeys, groupMap );
    }

    /**
     *
     * @param groupKeys
     * @param groupMap
     * @returns an object containing the widget definitions. format is the following:
     * {
     *   'groups0.label': 'groupLabel',
     *  'groups0.criteriaGroups0.criteria0.field': 'Entity.path.to.property',
     *  'groups0.criteriaGroups0.criteria0.value': 'propertyValue'
     * }
     *
     * There may be multiple criteria for each group, so the index is used to differentiate between them.
     * There may be multiple groups, so the index is used to differentiate between them.
     */
    private buildWidgetDefinitions( groupKeys: string[], groupMap: Map<string, { criteria: string; value: string; fromCriteriaGroup: boolean }[]> ) {
        const result: any = {};
        for ( let i = 0; i < groupKeys.length; i++ ) {
            const groupId = groupKeys[i];
            const matchingWidgetGroup = this.widgetGroups.find( wg => wg.id === groupId );
            if ( !matchingWidgetGroup ) {
                continue;
            }

            result[`${HisSearchConstants.GROUPS}${i}.${HisSearchConstants.GROUP_LABEL}`] = matchingWidgetGroup.label;

            const criteriaPairs = groupMap.get( groupId ) ?? [];
            for ( let j = 0; j < criteriaPairs.length; j++ ) {
                const { criteria, value, fromCriteriaGroup } = criteriaPairs[j];

                if ( fromCriteriaGroup ) {
                    result[
                        `${HisSearchConstants.GROUPS}${i}.` +
                        `${HisSearchConstants.CRITERIA_GROUPS}${j}.` +
                        `${HisSearchConstants.CRITERIA}${j}.` +
                        `${HisSearchConstants.FIELD}`
                    ] = criteria;
                    result[
                        `${HisSearchConstants.GROUPS}${i}.` +
                        `${HisSearchConstants.CRITERIA_GROUPS}${j}.` +
                        `${HisSearchConstants.VALUE}`
                    ] = value;
                } else {
                    result[
                        `${HisSearchConstants.GROUPS}${i}.` +
                        `${HisSearchConstants.CRITERIA}${j}.` +
                        `${HisSearchConstants.FIELD}`
                    ] = criteria;
                    result[
                        `${HisSearchConstants.GROUPS}${i}.` +
                        `${HisSearchConstants.CRITERIA}${j}.` +
                        `${HisSearchConstants.VALUE}`
                    ] = value;
                }
            }
        }

        return result;
    }

    collectLazyWidgets( widgetGroups: HisWidgetGroup[] ): HisSelectWidget[] {
        const lazyWidgets: HisSelectWidget[] = [];
        for ( let widgetGroup of this.widgetGroups ) {
            lazyWidgets.push( ...widgetGroup.collectLazyWidgets() );
        }
        return lazyWidgets;
    }

    presetLazyInputFields( presets: any ) {
        if ( !presets ) {
            return;
        }
        const lazyWidgets: HisSelectWidget[] = this.collectLazyWidgets( this.widgetGroups );
        const optionByIdRequests: OptionByIdRequest[] = [];
        for ( let widget of lazyWidgets ) {
            let preset: any;
            if ( HisQueryParamUtils.isFlatObjectFormat( presets ) ) {
                preset = HisWidgetUtils.getPresetForWidget( widget, presets );
            } else {
                preset = presets[widget.id];
            }
            if ( !preset ) {
                continue;
            }

            // make sure model & view are updated.
            // (see his-widget-select#presetInputFields)
            widget.value = { label: null, id: null };

            if ( preset === 'ISNULL' && widget.showNullItem ) {
                let isNullOption = new HisOption();
                isNullOption.id = 'ISNULL';
                isNullOption.label = null;
                Object.assign( widget.value, isNullOption );
                widget.value = isNullOption;
                continue;
            }

            optionByIdRequests.push( new OptionByIdRequest( widget.optionsKey, [preset] ) );
        }
        console.log( 'presetting lazy select fields via options: ', optionByIdRequests );

        this.searchService.loadOptionsByIds( this.searchConfiguration.configFile, optionByIdRequests ).subscribe(
            ( result: SelectedOptions[] ) => {

                if ( !result ) {
                    return;
                }

                for ( let selectedOption of result ) {
                    if ( !selectedOption || !selectedOption.selectedOptions || selectedOption.selectedOptions.length == 0 ) {
                        continue;
                    }
                    const matchedWidget = lazyWidgets.find( widget => widget.optionsKey === selectedOption.selectFrom );
                    // (see his-widget-select#presetInputFields)
                    Object.assign( matchedWidget.value, selectedOption.selectedOptions[0] );
                    matchedWidget.value = selectedOption.selectedOptions[0];
                }
            }
        );
    }

    /**
     * Resets the current `widgetsToDisplayFromSearchSet`
     */
    public resetWidgetsToDisplayFromSearchSet() {
        this.widgetsToDisplayFromSearchSet.forEach( widget => widget.isActiveBySearchSet.set( false ) );
        this.widgetsToDisplayFromSearchSet = [];
    }

    /**
     * Sets the current `widgetsToDisplayFromSearchSet` to the provided `widgets`
     * 
     * Also takes care of resetting the previous widgets to keep consistent.
     */
    setWidgetsToDisplayFromSearchSet( widgets: HisWidgetBase<any>[] ) {
        this.resetWidgetsToDisplayFromSearchSet();
        widgets.forEach( widget => widget.isActiveBySearchSet.set( true ) );
        this.widgetsToDisplayFromSearchSet = widgets;
    }

    /**
     * Returns the current `widgetsToDisplayFromSearchSet`
     */
    getWidgetsToDisplayFromSearchSet() {
        return this.widgetsToDisplayFromSearchSet;
    }

    public clearAllWidgetValues() {
        if ( !this.widgetGroups ) return;
        for ( const widgetGroup of this.widgetGroups ) {
            for ( const widget of widgetGroup.widgets ) {
                widget.value = null;
                widget.originalValue = null;
                if ( widget instanceof HisWidgetBaseSelect ) {
                    widget.not = false;
                    widget.originalNot = false;
                }
            }
            // Also clear criteria group widgets to prevent stale values
            // when loading a new search set after a previous one
            for ( const criteriaGroup of widgetGroup.criteriaGroups ) {
                for ( const widget of criteriaGroup.widgets ) {
                    widget.value = null;
                    widget.originalValue = null;
                    if ( widget instanceof HisWidgetBaseSelect ) {
                        widget.not = false;
                        widget.originalNot = false;
                    }
                }
            }
            widgetGroup.criteriaGroups = [];
        }
    }
}
